module.exports = __webpack_public_path__ + "593a3d53/img/arrow-export-icon.a3345173.svg";